export default __webpack_public_path__ + "static/media/plus.5d3f59de.svg";